import { render, staticRenderFns } from "./block-rental-tolls.vue?vue&type=template&id=23ceb863&scoped=true&"
import script from "./block-rental-tolls.vue?vue&type=script&lang=js&"
export * from "./block-rental-tolls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ceb863",
  null
  
)

export default component.exports